/** 作品末端のタブに何個の`TagButton`を表示するか？を算出する関数 */
export const tagSplitLength = (total: number, onePageNumber: number) => {
  if (20 < total && total <= 40) return 2;
  if (40 < total && total <= 60) return 3;
  if (60 < total && total <= 80) return 4;
  if (80 < total && total <= 119) return 5;
  if (119 < total) return Math.round(total / onePageNumber);
  return 1;
};
